export const WAVEFORM_BAR_WIDTH = 3;
export const WAVEFORM_BAR_GAP = 2;
export const WAVEFORM_SAMPLE_MS = 50;

// Conversational speech sits around 0.05-0.15 RMS; the gain and sqrt curve
// lift that to roughly 40-75% of the bar height.
const LEVEL_GAIN = 4;

export const rmsLevel = (samples: Uint8Array): number => {
  if (samples.length === 0) {
    return 0;
  }
  let sum = 0;
  for (const sample of samples) {
    const centered = (sample - 128) / 128;
    sum += centered * centered;
  }
  const rms = Math.sqrt(sum / samples.length);
  return Math.min(1, Math.sqrt(rms * LEVEL_GAIN));
};

export const pushLevel = (
  buffer: number[],
  level: number,
  capacity: number,
): number[] => {
  buffer.push(level);
  if (buffer.length > capacity) {
    buffer.splice(0, buffer.length - Math.max(0, capacity));
  }
  return buffer;
};

export const waveformCapacity = (width: number): number =>
  Math.max(
    0,
    Math.floor(
      (width + WAVEFORM_BAR_GAP) / (WAVEFORM_BAR_WIDTH + WAVEFORM_BAR_GAP),
    ),
  );

export const formatElapsed = (ms: number): string => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};
